<template>
  <v-card>
    <v-card-title class="green lighten-4 font-weight-bold primary--text">{{
      indicacao.id == 0 ? "Nova indicação PCD" : "Editar indicação PCD"
    }}</v-card-title>
    <v-card-subtitle class="green lighten-4">{{ indicacao.id == 0 ? 'Cadastrar PCD' : 'Corrigir dados PCD'  }}</v-card-subtitle>
    <v-card-text class="pt-3">
      <v-form ref="form">
        <v-text-field
          label="Nome do PCD"
          v-model="indicacao.nome"
          :rules="[(v) => !!v || 'Nome é obrigatório']"
        ></v-text-field>
        <v-text-field
          label="CPF PCD"
          v-mask="'###########'"
          v-model="indicacao.cpf"
          :rules="[(v) => !!v || 'CPF é obrigatório']"
        ></v-text-field>
        <v-text-field
          label="Data de nascimento PCD"
          type="date"
          v-model="indicacao.dtnascimento"
          :rules="[(v) => !!v || 'Informe a data de nascimento do PCD']"
        ></v-text-field>
        <v-text-field
          label="Cidade PCD"
          v-model="indicacao.cidade"
          :rules="[(v) => !!v || 'Informe a cidade do PCD']"
        ></v-text-field>
        <v-text-field
          label="Endereço PCD"
          v-model="indicacao.endereco"
          :rules="[(v) => !!v || 'Informe o endereço do PCD']"
        ></v-text-field>
        <v-text-field
          label="Telefone PCD"
          v-model="indicacao.telefone_pcd"
          :rules="[(v) => !!v || 'Informe o telefone do PCD']"
          v-mask="'(##) #########'"
        ></v-text-field>
        <v-text-field
          label="Seu telefone de contato"
          v-model="indicacao.telefone_colaborador"
          :rules="[(v) => !!v || 'Informe seu telefone de contato']"
          v-mask="'(##) #########'"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        rounded
        color="success"
        min-width="220"
        @click="confirmarIndicacao()"
        >Confirmar indicação</v-btn
      >
      <slot></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
export default {
  computed: mapState("pcd", ["indicacao"]),
  data: () => ({
    confirmandoIndicacao: false,
  }),
  methods: {
    ...mapActions("pcd", ["getMinhasIndicacoes"]),
    async confirmarIndicacao() {
      if (this.$refs.form.validate()) {
        this.confirmandoIndicacao = true;
        await axios
          .post(
            "/colaborador/indicacao-pcd/salvar-indicacao",
            JSON.stringify(this.indicacao)
          )
          .then(async (res) => {
            if (res.data.success) {
              this.$router.go()                            
            } else this.$toasted.error(res.data.msg);
          })
          .catch((e) => this.$toasted.error(e));
        this.confirmandoIndicacao = false;
      }
    },
  },
};
</script>

<style>
</style>